let userForm = require('../../actions/account/user-form');
let content = require('../../actions/layout/content');
let utils = require('../../actions/utils');

module.exports = {
    onSaveUserInfoChange: [
        content.setIsLoading(true),
        [
            userForm.updateUserInfo,
            {
                success: [
                    userForm.initUserForm
                ],
                error: [
                    utils.set(['account', 'userForm', 'isError'], true)
                ]
            }
        ],
        content.setIsLoading(false)
    ],

    onCancelUserInfoChange: [
        userForm.resetUserForm
    ],

    selectUserType: [
        userForm.selectUserType(['account', 'userForm'])
    ],
    selectCountry: [
        utils.setArgByFunction('selectedValue', (args) => Number(args['selectedValue'])),
        utils.setFromArgsToState('selectedValue', ['account', 'userForm', 'form', 'countryId']),
        [
            utils.isEqual(['account', 'userForm', 'computed', 'isUserTypeSelectEnabled'], false),
            {
                yes: [
                    utils.set(['account', 'userForm', 'form', 'userType'], 1),
                    utils.unset(['registration', 'userTypeRadio']),
                    utils.set(['account', 'userForm', 'userTypeRadio', 1], true)
                ],
                no: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/account/user-form.js